import React, { useState } from "react";

// Request a right-sized, compressed variant instead of the multi-MB original.
// Pexels' image CDN honors ?auto=compress&cs=tinysrgb&w=N (a 400px variant is
// ~30KB vs 2-4MB). Non-Pexels hosts pass through untouched.
export function sized(src, w) {
  if (!src) return src;
  try {
    const u = new URL(src);
    if (u.hostname.endsWith("images.pexels.com")) {
      u.searchParams.set("auto", "compress");
      u.searchParams.set("cs", "tinysrgb");
      u.searchParams.set("w", String(w));
      return u.toString();
    }
  } catch { /* relative or malformed URL — leave as-is */ }
  return src;
}

// Dish image with a graceful fallback: if the URL is missing or fails to load,
// render a warm gradient tile with the dish's initial instead of a broken image.
// `w` = target CSS width × ~2 for retina (default suits the 2-col menu grid).
export default function FoodImg({ src, alt, className = "", w = 400 }) {
  const [broken, setBroken] = useState(false);
  if (!src || broken) {
    return (
      <div className={`${className} grid place-items-center bg-gradient-to-br from-[var(--qd-cream)] to-orange-100`} aria-hidden>
        <span className="font-display font-black text-2xl text-[var(--qd-primary)]/40 select-none">
          {(alt || "?").trim().charAt(0).toUpperCase()}
        </span>
      </div>
    );
  }
  return <img src={sized(src, w)} alt={alt} loading="lazy" decoding="async" className={className} onError={() => setBroken(true)} />;
}
